import { api } from "@services/api"

import type {
  ContactSearchResponse,
  OrganizationOption,
  TimelineResponse,
} from "../types/conversation-timeline"

export async function getOrganizations(): Promise<OrganizationOption[]> {
  const { data } = await api.get<OrganizationOption[]>("/admin/views/organizations")
  return data
}

export async function searchContacts(
  query: string,
  organizationId?: string,
  limit = 20,
  offset = 0
): Promise<ContactSearchResponse> {
  const params: Record<string, string | number> = { q: query, limit, offset }
  if (organizationId) params.organization_id = organizationId
  const { data } = await api.get<ContactSearchResponse>("/admin/views/contacts/search", {
    params,
  })
  return data
}

export interface ContactConversationsResponse {
  contact: {
    id: string
    phone_number: string
    name: string | null
    profile_name: string | null
    organization_id: string
    is_blocked: boolean
  }
  conversations: Array<{
    id: string
    channel_id: string
    status: string
    message_count: number
    last_message_at: string | null
    is_handoff_active: boolean
    handoff_reason: string | null
  }>
}

export async function getContactConversations(
  contactId: string
): Promise<ContactConversationsResponse> {
  const { data } = await api.get<ContactConversationsResponse>(
    `/admin/views/contacts/${contactId}/conversations`
  )
  return data
}

export async function getConversationTimeline(
  conversationId: string,
  limit = 50,
  before?: string
): Promise<TimelineResponse> {
  const params: Record<string, string | number> = { limit }
  if (before) params.before = before
  const { data } = await api.get<TimelineResponse>(
    `/admin/views/conversations/${conversationId}/timeline`,
    { params }
  )
  return data
}
